"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
const useScrollLock = isLocked => {
  const $ = _c(5);
  const [locked, setLocked] = useState(isLocked ?? false);
  let t0;
  let t1;
  if ($[0] !== locked) {
    t0 = () => {
      if (locked) {
        const scrollY = window.scrollY;
        const originalStyle = window.getComputedStyle(document.body).overflow;
        const originalPaddingRight = window.getComputedStyle(document.body).paddingRight;
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
        return () => {
          document.body.style.overflow = originalStyle;
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.width = "";
          document.body.style.paddingRight = originalPaddingRight;
          window.scrollTo(0, scrollY);
        };
      }
    };
    t1 = [locked];
    $[0] = locked;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== locked) {
    t2 = {
      locked,
      setLocked
    };
    $[3] = locked;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useScrollLock;